import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import Payment from '../../service/pay/pay';
import { useNavigate } from 'react-router-dom';
import CouponService from '../../service/coupon/Coupon';
import { isLogin } from '../../utils/auth';
import PageTop from '../components/pageTop/PageTop';
import PlanPriceGuide from '../components/pay/plan/PlanPriceGuide';
import ComparePlan from '../components/pay/plan/ComparePlan';
import ComparePrice from '../components/pay/plan/ComparePrice';
import { PageContainer } from '../components/common/PageComponent.style';
import ConfirmAlert from '../components/alert/ConfirmAlert';
import { isAfterTime } from '../../utils/eventTime';
export interface PlanItem {
  name: string;
  type: string;
  plan_id: number;
  plan_prc: number;
  plan_name: string;
  coupon_name: string;
  is_discount: string;
}

const PaymentPlan = () => {
  const navigate = useNavigate();
  const server = new URL(
    process.env.REACT_APP_HOST_API || 'http://localhost:3333/',
  ).origin;

  const [showCouponModal, setShowCouponModal] = useState(false);

  useEffect(() => {
    const hasShown = sessionStorage.getItem('couponModal');
    if (!hasShown) {
      setShowCouponModal(true);
    }
  }, []);

  return (
    <PageContainer>
      <TopBanner onClick={() => navigate('/promotion/땅집고옥션-럭키-이벤트')}>
        <TopBannerImg
          src="/assets/images/banner/payment-topbanner-lucky.png"
          alt="banner"
        />
      </TopBanner>
      <PageTop logo hasSearch={false} hasBackCloseButton={false} />

      <TitleSection>
        <PageTitle>땅집고옥션 요금제 안내</PageTitle>
        <PageDescription>
          지금 바로 구매하고 유료 회원에게만 제공되는 <br />
          땅집고옥션만의 차별화된 서비스를 누려보세요
        </PageDescription>
      </TitleSection>

      <PlanPriceGuide />

      <CardBenefitSection>
        <CardBenefitSectionTitle>
          <img src="/assets/images/icon/info-black.svg" alt="" />
          추가 혜택 안내
        </CardBenefitSectionTitle>
        <CardBenefitSectionContent>
          <CardBenefit>
            ・
            <CardBenefitText>
              최대 6개월! 무이자 할부
              <CardName>신한, KB, 국민, 하나, 롯데, 농협, 우리, 전북</CardName>
              <CardDesc>
                개인사업자, 법인, 체크카드, 기프트카드, BC계열 무이자 제외
              </CardDesc>
            </CardBenefitText>
          </CardBenefit>
          <CardBenefit>
            ・<CardBenefitText>쿠폰 적용 시 추가 할인가능</CardBenefitText>
          </CardBenefit>
        </CardBenefitSectionContent>
      </CardBenefitSection>

      <ComparePlan />
      <ComparePrice />
      <InfoBox>
        <InfoBoxTitle>
          <img src="/assets/images/icon/info-black.svg" alt="" />
          요금제 유의사항
        </InfoBoxTitle>
        <InfoContent>
          <InfoItem>
            <div>・</div>모든 요금제는 부가세가 포함된 금액입니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>스탠다드 지역권을 구매하실 경우 일부 지역 서비스는
            제한됩니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>이용기간 안내: 1개월 상품은 구매일 기준 30일간 이용
            가능합니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>3개월 이상 전국 스탠다드 요금제 구매 시, 퀀트 리포트
            열람권, 알고리즘 만들기 이용권, AI 탐색권 등 이용권은 요금제 가입일
            기준으로 1개월마다 지급됩니다.
            <br />
            (예: 7월 10일 전국 스탠다드 구매 시 퀀트 리포트 열람권 100건,
            알고리즘 만들기 이용권 100건, AI 탐색권 500건 충전, 8월 9일에 다음
            충전)
          </InfoItem>
          <InfoItem>
            <div>・</div>모든 이용권은 해당 30일 내에만 사용 가능하며,
            이월되거나 누적되지 않습니다.
            <br />
            요금제 사용 중에만 지급되며, 기간 종료 시 남은 이용권은 자동
            소멸됩니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>1년권(365일)의 경우, 총 12회에 걸쳐 최대 1,200건의 퀀트
            리포트 열람권과 알고리즘 만들기 이용권, 6,000건의 AI 탐색권이
            순차적으로 지급됩니다.
          </InfoItem>
          {/* <InfoItem>
              <div>・</div>AI 경공매 찾기 탐색권 : 무료 회원 매 월 1일 30건 /
              스탠다드 결제일 기준 30일마다 300건/ 프리미엄 결제일 기준 30일마다
              1000건
            </InfoItem> */}
        </InfoContent>
      </InfoBox>
      <Footer />
      {!isAfterTime() && showCouponModal && (
        <ConfirmAlert
          title="이용 가능한 쿠폰이 있습니다."
          desc={`최대 5만원 할인부터, 1개월 이용기간 연장까지\n지금 바로 쿠폰 받고 이용해보세요!`}
          blueButtonText="쿠폰 받기"
          onBlueClick={() => {
            navigate('/promotion/땅집고옥션-럭키-이벤트');
          }}
          onClose={() => {
            if (isLogin()) {
              sessionStorage.setItem('couponModal', 'true');
            }
            setShowCouponModal(false);
          }}
        />
      )}
    </PageContainer>
  );
};

export default PaymentPlan;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  background: #fff;
  word-break: keep-all;
`;

const TopBanner = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: #3048f3;
  cursor: pointer;
`;

const TopBannerImg = styled.img`
  width: 100%;
  max-width: 360px;
  aspect-ratio: 1080/120;
`;

const TopBannerText = styled.div<{ $highlight?: boolean }>`
  color: ${({ $highlight }) => ($highlight ? '#FD511B' : '#A26145')};
  font-family: 'Gmarket Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -1px;
`;

const TitleSection = styled.div`
  display: flex;
  padding: 40px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const PageTitle = styled.div`
  color: #222;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.48px;
  width: 100%;
`;

const PageDescription = styled.div`
  color: #222;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
  width: 100%;
`;

const CardBenefitSection = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background: #f7f7fa;
`;

const CardBenefitSectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardBenefitSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const CardBenefit = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;

  color: #222;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardBenefitText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

const CardName = styled.div`
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardDesc = styled.div`
  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const InfoBox = styled.div`
  display: flex;
  padding: 24px 16px 40px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  background: #f7f7fa;
`;

const InfoBoxTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;

  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
